module.exports = __webpack_public_path__ + "img/belt_center_talk.ef548d1c.gif";